<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" >
            </el-form>
            <el-button type="primary" @click="edit({})">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="name"
                    label="分类名称" >
                </el-table-column>
                 <!-- <el-table-column
                    min-width="180"
                    prop="flag"
                    label="分类标识" >
                </el-table-column> -->
                <el-table-column
                    min-width="180"
                    label="顺序调整" >
                    <template slot-scope="scope">
                        <i class="el-icon-arrow-up font20 order_btn" @click="up(scope.row, scope.$index)"></i>
                        <i class="el-icon-arrow-down font20 order_btn" @click="down(scope.row, scope.$index)"></i>

                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-popconfirm @onConfirm="del(scope.row)"
                                       title="确认删除该分类吗？" >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>

                    </template>
                </el-table-column>
            </el-table>
        </div>
<ArticleTypeEditDrawer v-if="showEdit" :item="currentArticleType"
                            @close="showEdit = false" @submit="loadData"></ArticleTypeEditDrawer>
    </div>
</template>

<style scoped>
    .order_btn {
        display: inline-block;
        background: var(--primary);
        color: white;
        margin: 0 5px;
        cursor: pointer;
        padding: 2px;
    }
</style>
<style>

</style>

<script>

    import {mapMutations} from 'vuex';
    import ArticleTypeEditDrawer from "./ArticleTypeEditDrawer";
    export default {
        components: {
            ArticleTypeEditDrawer
        },
        props: [
            "attr"
        ],
        data() {
            return {
                showEdit: false,
                tableData: [ ],
                editItem: {},
            }

        },

        watch: {
           
        },

        methods: {
            ...mapMutations(["openTab"]),
            edit(item) {
                this.currentArticleType = {...item};
                this.showEdit = true;
                // this.$showPrompt("输入分类名称", item.name, name => {
                //     this.$ajaxPost("/articleType/save", {
                //         articleType: {
                //             name: name,
                //             id: item.id
                //         }
                //     }, data => {
                //         this.loadData();
                //     })
                // })

            },

            del(item) {
                this.$ajaxGet("/articleType/delArticleById/" + item.id, (data) => {
                    this.loadData();
                })
            },

            // modifyEnable(item) {
            //     this.$ajaxGet("/articleType/toggleEnable/" + item.id + "-" + item.enable);
            // },

            loadData() {
                this.$ajaxGet("/articleType/listArticleType", (data) => {
                    this.tableData = data.result;
                    this.showEdit = false;
                })
            },
            up(item, index) {
                if (index == 0) {
                    return;
                } else {
                    let prevItem = this.tableData[index-1];
                    this.$ajaxGet(`/articleType/updateRank/${item.id}-${item.rank}-${prevItem.rank}`, data=> {
                        this.loadData();
                    } )
                }
            },
            down(item, index) {
                if (index == this.tableData.length - 1) {
                    return;
                } else {
                    let afterItem = this.tableData[index+1];
                    this.$ajaxGet(`/articleType/updateRank/${item.id}-${item.rank}-${afterItem.rank}`, data=> {
                        this.loadData();
                    } )
                }

            },
            preview(item) {
            }


        },

        created() {
            this.loadData();
        }

    }
</script>
